import { Box } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import { ForbiddenPage } from 'packages/eid-ui'
import { useTranslation } from 'react-i18next'

const ns = 'public'
const useStyles = makeStyles(() => ({
    noAccessInfo: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: '10rem',
        '& > div > div:first-of-type p': {
            fontSize: '6vw !important',
            marginLeft: '3rem !important',
        },
        '& > div > div:last-of-type p': {
            fontSize: '1vw !important',
            marginLeft: '3rem !important',
        },
    },
}))

const NoAccessInfo = () => {
    const { t } = useTranslation()
    const classes = useStyles()
    return (
        <Box className={classes.noAccessInfo}>
            <ForbiddenPage
                description={t(`${ns}:MsCommonAnonymous_ForbiddenPageMessage`)}
                linkText={t(`${ns}:MsCommonAnonymous_HomePage`)}
                errorCode={'403'}
                showLink={true}
            />
        </Box>
    )
}

export default NoAccessInfo
